<template>
    <div id="listCreditNote">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Credit/Debit Note List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                        <router-link v-if="canAdd" class="btn btn-primary" v-bind:to="{name: 'CreditNoteCreate'}"> <i class="fp-add"> </i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content debit-note-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'creditNoteList'" ref="filterCreditNote" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange" :moduleName="'creditNoteList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listCreditNoteTable"
                                      mode="remote"
                                      title="Credit/Debit Notes"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-select-all="onSelectAll"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'bottom',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: credit_note_value,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <router-link v-if="canUpdate" title="Edit Credit Note" class="fp-edit" v-bind:to="{name: 'CreditNoteEdit',params:{id:props.row.id}}"></router-link>
                                              </div>
                                              <div v-if="props.column.field == 'note_number' && canView">
                                                  <router-link title="View Credit Note" class="color-blue" v-bind:to="{name: 'CreditNoteView',params:{id:props.row.id}}">{{props.row.note_number}}</router-link>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <button v-if="credit_note_value" id="deleteCreditNoteBtn" v-on:click.prevent="creditNoteDelete" class="btn btn-primary">Delete</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import EventBus from ".././event-bus";

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
    name: "CreditNoteList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Credit-Debit Note List | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        firstLoad : 0,
        userColumns:[],
        columns: [
             {
                label: 'Actions',
                field: 'action',
                sortable: false,
            },
            {
                label: '# Note Number',
                field: 'note_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Note Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
                label: 'Note Type',
                field: 'note_type',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Note Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Customer',
                field: 'customer',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: '# Invoice',
                field: 'invoice',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Invoice", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Vendor',
                field: 'vendor',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vendor", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: '# Vendor Invoice',
                field: 'bill',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Bill", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Amount',
                field: 'amount',
                filterable: true,
                fpFieldType:"integer",
                type:"number",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Date Of Issue',
                field: 'date_of_issue',
                hidden:false,
                fpFieldType:"date",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Expiry Date',
                field: 'expiry_date',
                hidden:false,
                fpFieldType:"date",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        totalRecords: 0,
        permissions:[],
        loading:false,
        cantAccessPage:"",
        credit_note_value:false,
        canView:false,
        canAdd:false,
        canUpdate:false,
        action:'list',
        pageKey:"_cr_dr_notes_list_",
        batchProcess:0,
        batchNum:"",
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_credit_note') {
                    self.cantAccessPage = true;
                }
                if (permissions.name == 'delete_credit_note') {
                    self.credit_note_value = true;
                }
                if (permissions.name == 'view_credit_note') {
                    self.canView = true;
                }
                if (permissions.name == 'add_credit_note') {
                    self.canAdd = true;
                    self.canUpdate = true;
                }

            });
        }
    },
    created: function() {
    },
    mounted: function () {

        this.getPermissions();

    },
    methods: {
        cancelAll: function (cancelAll) {
          this.$refs.listCreditNoteTable.unselectAllInternal();
        },
        selectionChanged(param) {
            var self = this;
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
            // console.log(self.computed.selectedRows);
            var rowData = self.$refs['listCreditNoteTable'].selectedRows;
            console.log(rowData);
        },
        // exportReports: function() {
        //     var self = this;
        //     this.action = "export";
        //     this.loadList();
        // },
        loadList() {
            var self = this;

            var data = this.$refs['listCreditNoteTable'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(this.$refs['listCreditNoteTable'].selectedRows[i].id)
            }

            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action,
                all:self.serverParams.selectedAll,
                id:use
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/credit-note/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                         if ( self.action == "export" ||  self.action == "export_queue") {
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                              if ( self.action == "export" ) {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }
                          }
                          self.action = "list";
                          self.loadList();

                        }else if ( self.action == "delete" ) {

                            self.action = "list";
                            self.$refs.filterCreditNote.clearSelectAll();

                            self.$swal('','Note have been deleted successfully','success');
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();
                            //EventBus.$emit('clear-all-flags', false);   //hide alert of selection
                            return;
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }

                        // self.rows = data.content.row;
                        // self.totalRecords = data.content.totalRecords;
                        self.filteredFlag = false;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'credit-debit-note-list');
                }
            });
        },

        creditNoteDelete() {


            var self = this;
            self.$swal({
                    title: 'Are you sure that you want to delete this Credit/Debit Note?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.action = 'delete';
                        self.loadList();
                    } else {
                      console.log("no");
                    }
                });
            //var data = this.$refs['listCreditNoteTable'].selectedRows;
            // var use = [];
            // for (var i = 0; i < data.length; i++) {
            //     use.push(this.$refs['listCreditNoteTable'].selectedRows[i].id)
            // }

            // if (confirm('Are you sure that you want to delete this Credit/Debit Note? ')) {
            //     self.action = 'delete';
            //     self.loadList();
                // self.loading = true;
                // $("#deleteCreditNoteBtn").val("Deleting ...");
                // $.ajax({
                //     url: process.env.ROOT_API + "/credit-note/delete",
                //     type: "POST",
                //     data: 'id=' + use,
                //     headers : this.ajxHeaders
                //     dataType: 'json',
                //     success: function (data) {
                //         self.loading = false;
                //         setTimeout(function () {
                //         $(".alert-success").removeClass("show");
                //             $(".alert-success").addClass("hide");
                //         }, 10000);
                //         setTimeout(function () {
                //             $("#deleteCreditNoteBtn").val("Delete");
                //         }, 10000);
                //         if (data.code == '200') {
                //             self.loadList();
                //         }
                //     },
                //     error: function (jqXHR, exception) {
                //         self.loading = false;
                //         self.generateStatusCodeMessage(jqXHR,true,'credit-debit-note-delete');
                //     }
                // });
           // }
        }

    }

}
</script>




// WEBPACK FOOTER //
// src/components/accounting/CreditNoteList.vue